import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"search\"><path fill-rule=\"evenodd\" d=\"M14.13 16c.36 0 .73-.14 1-.4.55-.56.55-1.47 0-2.02l-2.86-2.86A6.75 6.75 0 0 0 6.77 0a6.78 6.78 0 0 0 0 13.55c1.25 0 2.4-.34 3.4-.93l2.95 2.95c.28.29.66.43 1.01.43m-7.36-5.28a3.96 3.96 0 0 1-3.94-3.95 3.96 3.96 0 0 1 3.94-3.94 3.96 3.96 0 0 1 3.95 3.94 3.96 3.96 0 0 1-3.95 3.95\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol